import Image from 'next/image'

import { Text } from '@wartek-id/text'

import useToggleSdkContext from 'utils/useToogleSdk'

interface KinerjaLogoProps {
  title?: string
}

const KinerjaLogo = ({ title = 'Pengelolaan Kinerja' }: KinerjaLogoProps) => {
  const toggles = useToggleSdkContext()
  const isToggleNewLogoEnabled = toggles?.['kinerja-new-logo-enabled'] ?? false

  return (
    <>
      <Image
        src="/images/kemendikbud2x.png"
        width={40}
        height={40}
        alt="Logo Tut Wuri Handayani"
        className="!select-none !pointer-events-none"
      />
      {isToggleNewLogoEnabled ? (
        <Image
          data-testid="kinerja-new-logo"
          src="/icon/e-pengelolaan-kinerja-logo.png"
          width={124}
          height={32}
          alt="Logo Pengelolaan-Kinerja"
          className="!select-none !pointer-events-none"
        />
      ) : (
        <>
          <Image
            src="/icon/guru-penggerak.svg"
            width={29}
            height={40}
            alt="Logo Merdeka Mengajar"
            className="!select-none !pointer-events-none"
          />
          <Text as="span" variant="heading-md" className="!pointer-events-none">
            {title}
          </Text>
        </>
      )}
    </>
  )
}

export default KinerjaLogo
